import omit from 'lodash/omit';

import adjustUrlParams from './adjustUrlParams';

const removeParamsFromUrl = (url: string, paramsToRemove?: string[] | null) => {
  return adjustUrlParams(
    currentParams => omit(currentParams, paramsToRemove ?? []),
    url
  );
};

export default removeParamsFromUrl;
